<template>
  <kst-page-details
    :actions="actions"
    @init="handleInit"
  >
    <b-tabs multiline v-model="activeTab" size="is-medium" type="is-boxed">
      <b-tab-item :label="tabs.Details">
        <Details :details="details"/>
        <Items :items="details.Items"/>
        <Total :details="details"/>
      </b-tab-item>
    </b-tabs>
  </kst-page-details>
</template>

<script>
import Info from "../HpadInfo.js";
import Model from "../HpadModel.js";
import Services from "../../../services/Api/HppAdjServices.js";

import Details from "./HpadD_Details.vue";
import Items from "./HpadD_Items.vue";
import Total from "./HpadD_Total.vue";

export default {
  components: {
    Details,
    Items,
    Total
  },
  data: () => ({
    actions: [],
    details: {},
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details
    }
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadDetails) {
      this.resetData(id);

      const config = Services.getDetailsData(id);
      loadDetails(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.details = data.Details;

      for (const item of this.details.Items) {
        Model.updateItemReadOnly(item);
      }
    },

    /*** custom ***/

    resetData(id) {
      const access = this.$kst.Access.create(Model.Access);
      this.actions = Model.Details.getActions(id, access);
      this.details = {};
    }
  }
}
</script>